import React from "react";
import { GoogleMap, Marker, InfoWindow } from "@react-google-maps/api";

const MapWithMarkers = ({
    center,
    zoom,
    markers,
    onMarkerClick,
    openMarkerId,
    onInfoWindowClose,
}) => {
    return (
        <GoogleMap
            zoom={zoom}
            center={center}
            mapContainerStyle={{ height: "500px", width: "100%" }}
        >
            {markers.map((marker) => (
                <Marker
                    key={marker.id}
                    position={marker.position}
                    onClick={() => onMarkerClick(marker.id)}
                >
                    {openMarkerId === marker.id && (
                        <InfoWindow
                            onCloseClick={() => onInfoWindowClose()}
                            position={marker.position}
                        >
                            <div className="map-address">
                                <h3>{marker.info.agentName}</h3>
                                <p>{marker.info.address}</p>
                                <p>
                                    <a href={`mailto:${marker.info.email}`}>{marker.info.email}</a>
                                </p>
                                <p>
                                    <a href={`tel:${marker.info.phone}`}>{marker.info.phone}</a>
                                </p>
                                {marker.info.resellerWebsiteUrl && (
                                    <p>
                                        <a href={marker.info.resellerWebsiteUrl} target="_blank" >
                                            {marker.info.resellerWebsiteUrl}
                                        </a>
                                    </p>
                                )}
                            </div>
                        </InfoWindow>
                    )}
                </Marker>
            ))}
        </GoogleMap>
    );
};

export default MapWithMarkers;
